import { library } from '@fortawesome/fontawesome-svg-core'

import { faTicketAlt } from '@fortawesome/pro-solid-svg-icons/faTicketAlt'
import { faCommentsAlt } from '@fortawesome/pro-solid-svg-icons/faCommentsAlt'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { faSync } from '@fortawesome/pro-solid-svg-icons/faSync'
import { faArrowAltLeft } from '@fortawesome/pro-solid-svg-icons/faArrowAltLeft'
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle'
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser'

library.add(faTicketAlt, faCommentsAlt, faPlus, faSync, faArrowAltLeft, faPlusCircle, faUser)
